import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: false
})
export class ContactComponent implements OnInit {
  el: any;

  constructor() { }

  ngOnInit(): void {
  }
  addAtSymbol() {
    this.el.nativeElement.querySelector('#myText').textContent = '&#64;text';
  }
}
